module.exports = __webpack_public_path__ + "img/hand-point-ribbon.eff14b07.svg";